import React, {Fragment} from 'react';
import {Route} from '../Router';
import { default as Userlist} from './userlist';
import { default as Edit } from './edit';
import { UsersNavigation } from './Navigation';

export default function(props){
    return (
        <Fragment>
            <Route path="/system/users" exact={true} component={Userlist} />
            <Route path="/system/users/:userId" component={Edit} />
        </Fragment>
    )
}